import './style.less';
import * as React from 'react';
import { Surface } from 'telstra-ui/components/surface/Surface';
import { SurfaceList, SurfaceListItem } from 'telstra-ui/components/list/List';
import { Button } from 'telstra-ui/components/button/Button';
import '../../applications/tpams-reports/components/new-card/style.less';
import global from '@applications';
import { IconTC } from '@components/icon-tc';
import { SvgIcon } from 'telstra-ui/components/svg/Icon';

interface ICardLoadingIndicatorProps {
    error?: boolean;
    cardTitle: string;
    tryAgain?: () => void;
}

export class TpamsCardLoadingIndicator extends React.PureComponent<ICardLoadingIndicatorProps> {
    constructor(props) {
        super(props);
    }

    public render() {
        const { error, cardTitle } = this.props;
        const loadingClassName = 'tl-loading';
        const headerClassName = '__heading ' + loadingClassName;
        const redesignDataRichTiles = global?.applications?.Platform?.redesignDataRichTiles;
        const redesignTilesPhase2 = global?.applications?.Platform?.redesignTilesPhase2;

        const cardHeight = redesignTilesPhase2
            ? '424px'
            : redesignDataRichTiles
                ? '320px'
                : '';
        return (
            <div
                className={`tc-dashboard-cards-container.container panel panel-default tc-tpams-rich-card-panel`}
                style={{ height: cardHeight }}
            >
                {error ? (
                    <Surface
                        width="100%"
                        height={cardHeight}
                        id="ui-tpams-rich-card"
                        className="tl-custom-width tl-surface-dashboard tc-tpams-surface-tile ui-card-error"
                        name="surface-flat"
                    >
                        <SurfaceList
                            header={this.renderErrorHeader()}
                            body={this.renderErrorBody()}
                            footer={this.renderErrorFooter()}
                        />
                    </Surface>
                ) : (
                    <Surface
                        className="tl-custom-width tl-surface-dashboard tc-tpams-surface-tile ui-card-loading"
                        height={cardHeight}
                        id="ui-tpams-rich-card"
                        name="surface-flat"
                    >
                        <SurfaceList
                            header={
                                <div className="tl-heading__container">
                                    <div className={headerClassName}>{cardTitle}</div>
                                </div>
                            }
                            body={
                                <>
                                    <SurfaceListItem
                                        itemHeading="10 reports"
                                        itemIcon="icon-system-chevron-right"
                                        itemDesc="10 reports added on 19 July 21"
                                        itemId={8}
                                        skeltonLoading={true}
                                    />
                                </>
                            }
                            footer={
                                <div className="tile-link-wrapper __button tl-list-footer-button show-reports-text-loader">
                                    <Button
                                        variant="primary"
                                        size="xSmall"
                                        className={loadingClassName}
                                        disabled={true}
                                    >
                                        Show reports
                                    </Button>
                                </div>
                            }
                        />
                    </Surface>
                )}
            </div>
        );
    }
    private renderErrorHeader() {
        return (
            <div className="tl-heading__container">
                <div className="__heading no-action" id="ui-tpams-rich-card-header">
                    {this.props.cardTitle}
                </div>
            </div>
        );
    }
    private renderErrorBody() {
        const { error, tryAgain } = this.props;
        return (
            <div className="tc-tpams-card-error">
                <div className="tc-tpams-card-error__body">
                    <SvgIcon
                        name="picto-empty-state"
                        className="tc-telstra-icon tc-tpams-card-error__body__icon"
                    />
                    <div
                        className="tc-tpams-card-error__body__icon__error"
                        id="ui-tpams-card-error-text"
                    >
                        {error && tryAgain ? 'Server error' : 'Loading error'}
                    </div>
                    <div
                        className="tc-tpams-card-error__body__icon__text"
                        id="ui-tpams-card-error-subtext"
                    >
                        There was an error loading this app.
                    </div>
                </div>
            </div>
        );
    }
    private renderErrorFooter() {
        const { error, tryAgain } = this.props;
        return error && tryAgain ? (
            <div
                id="ui-tpams-rich-card-try-again"
                className="tc-tpams-card-error__button tl-list-im-button"
                onClick={tryAgain}
            >
                <IconTC
                    name="retry"
                    size="sm-24"
                    className="tc-footer-try-again-icon"
                />
                <span className="tc-footer-text">Try again</span>
            </div>
        ) : (
            <div
                id="ui-tpams-rich-card-refresh"
                className="tc-tpams-card-error__button tl-list-im-button"
                onClick={this.handleErrorCallback()}
            >
                <SvgIcon
                    name="icon-system-refresh"
                    className="tc-footer-refresh-icon"
                />
                <span className="tc-footer-text">Refresh</span>
            </div>
        );
    }
    private handleErrorCallback() {
        return () => window.location.reload();
    }
}
